/**
 * Display formatting for doctor names.
 *
 * Managers type these however they like — "HIMANSHU MAHLA", "dr harsh shah" — so the
 * table looked ransom-note. This normalises presentation only; the stored value and
 * the CSV export keep exactly what was submitted.
 */

// Left alone because uppercase is correct for them.
const KEEP_UPPER = new Set([
  "MBBS", "MD", "MS", "DM", "DNB", "MCH", "FRCS", "MRCP", "DTCD", "ABPM",
  "ENT", "ICU", "OPD", "CT", "MRI", "HOD",
]);

function fixWord(word) {
  if (!word) return word;

  // Hyphenated and slashed compounds: format each part.
  if (/[-/]/.test(word)) {
    return word.split(/([-/])/).map((p) => (/[-/]/.test(p) ? p : fixWord(p))).join("");
  }

  const bare = word.replace(/[^A-Za-z]/g, "");
  if (!bare) return word;

  // "Dr", "Dr." and friends get a trailing dot for consistency.
  if (/^dr$/i.test(bare)) return "Dr.";
  if (/^(prof|mr|mrs|ms)$/i.test(bare)) {
    return bare.charAt(0).toUpperCase() + bare.slice(1).toLowerCase() + ".";
  }

  if (KEEP_UPPER.has(bare.toUpperCase())) return word.toUpperCase();

  // A lone letter is an initial: "R" -> "R."
  if (bare.length === 1) return `${bare.toUpperCase()}.`;

  // Keep any leading punctuation, e.g. "(Cardiology"
  const lead = word.match(/^[^A-Za-z]*/)[0];
  const rest = word.slice(lead.length);
  return lead + rest.charAt(0).toUpperCase() + rest.slice(1).toLowerCase();
}

export function formatDoctorName(raw) {
  const s = (raw || "").trim();
  if (!s) return "";
  // Long entries are usually a hospital listing several doctors rather than one
  // name; re-casing those does more harm than good, so leave them as submitted.
  if (s.length > 60) return s;
  return s.split(/\s+/).map(fixWord).join(" ");
}

export default formatDoctorName;
